/*
 * Member Sale 2026 — product page price display
 * ---------------------------------------------------------------
 * Companion to assets/member-sale-2026.js (the collection page
 * version). Loaded only when sections/member-sale-2026-product.liquid
 * decides the CURRENT product belongs to exactly one Member Sale
 * tier collection — see that file for the Liquid-side guard.
 *
 * Rewrites the price shown in the product page's price block to
 * look like the theme's own native "on sale" state (struck-through
 * regular price + member price), using this page's own price
 * classes, plus a "MEMBER -X%" badge using the same badge pattern
 * this page already uses for real sales.
 *
 * IMPORTANT — this only happens when the shopper reached this product
 * page by clicking through from /collections/member-sale-2026. If the
 * same product is opened any other way (another collection, search,
 * the homepage, a direct/shared link, a fresh tab from a bookmark),
 * this script leaves the ordinary price exactly as Shopify rendered
 * it. See cameFromMemberSaleCollection() below for how that's checked.
 * (This is a display convenience, not an access wall: the computed
 * member price is still present in this page's HTML source for
 * anyone who inspects it — it just isn't shown visually unless the
 * referral check passes.)
 *
 * Display-only — never changes a Shopify price or compare-at price,
 * never touches checkout or discount logic.
 *
 * TO REMOVE AFTER THE SALE: delete this file (see the removal
 * steps in sections/member-sale-2026-product.liquid).
 */
(function () {
  'use strict';

  var REFERRAL_PREFIX = 'member-sale-2026:from:';
  var COLLECTION_PATH = '/collections/member-sale-2026';

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // True only when the shopper's last click, on this collection page,
  // was on THIS product's card (set by assets/member-sale-2026.js), or
  // — as a fallback, e.g. if sessionStorage isn't available — when the
  // browser reports this page's own referrer as the member sale
  // collection page.
  function cameFromMemberSaleCollection() {
    try {
      if (sessionStorage.getItem(REFERRAL_PREFIX + window.location.pathname) === '1') {
        return true;
      }
    } catch (err) {
      // sessionStorage unavailable — fall through to the referrer check.
    }

    if (document.referrer) {
      try {
        var referrer = new URL(document.referrer);
        if (referrer.origin === window.location.origin &&
            referrer.pathname.indexOf(COLLECTION_PATH) === 0) {
          return true;
        }
      } catch (err) {
        // malformed/unavailable referrer — treat as "no".
      }
    }

    return false;
  }

  function init() {
    if (!cameFromMemberSaleCollection()) {
      return;
    }

    var dataEl = document.getElementById('member-sale-2026-product-pricing-data');
    if (!dataEl) {
      return;
    }

    var entry;
    try {
      entry = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error('[Member Sale 2026] Could not parse product pricing data JSON.', err);
      return;
    }

    // The theme names the price wrapper "Price-<section id>"; there can
    // be more than one price block on a product page (e.g. a sticky
    // add-to-cart bar), so update every one of them.
    var priceWraps = document.querySelectorAll('[id^="Price-"]');
    priceWraps.forEach(function (wrap) {
      var priceEl = wrap.querySelector('.price');
      if (!priceEl) {
        return;
      }

      var container = priceEl.querySelector('.price__container');
      if (!container) {
        return;
      }

      priceEl.classList.add('price--on-sale', 'product__price--sale');

      var fromPrefix = entry.varies
        ? '<small>' + escapeHtml(entry.fromLabel || '') + '</small> '
        : '';

      container.innerHTML =
        '<div class="price__regular" hidden>' +
          '<span class="price-item price-item--regular">' + escapeHtml(entry.regular) + '</span>' +
        '</div>' +
        '<div class="price__sale">' +
          '<span class="price-item price-item--sale price-item--last">' +
            fromPrefix + escapeHtml(entry.member) +
          '</span>' +
          '<span><s class="price-item price-item--regular">' + escapeHtml(entry.regular) + '</s></span>' +
        '</div>';

      if (!priceEl.querySelector('.member-sale-tag')) {
        var badgeWrap = document.createElement('div');
        badgeWrap.className = 'product__sale';
        badgeWrap.setAttribute('data-price-off', '');
        badgeWrap.innerHTML =
          '<span class="product__price--off member-sale-tag" data-price-off-badge>' +
            escapeHtml((entry.badgeLabel || 'MEMBER') + ' -' + entry.percent + '%') +
          '</span>';
        priceEl.appendChild(badgeWrap);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();